import React from 'react';

/**
 * options: [{ value, label }]. Usado para Monthly/Yearly, Personal/Business,
 * y en Login para elegir metodo (Email · Tarjeta · Maestra).
 */
function SegmentedControl({ options, value, onChange, className = '' }) {
  return (
    <div className={`sgc-segmented ${className}`} role="tablist">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          className={`sgc-segmented__item ${value === opt.value ? 'sgc-segmented__item--active' : ''}`}
          onClick={() => onChange?.(opt.value)}
        >
          {opt.icon && <opt.icon width={16} height={16} aria-hidden="true" />}
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
